// Shared ownership prevents nested sheets from releasing each other's locks.
const surfaces = [];
const locks = new WeakMap();

function lock(element, property, value) {
    if (!element) return () => {};
    let properties = locks.get(element);
    if (!properties) locks.set(element, (properties = new Map()));
    let state = properties.get(property);
    if (!state) {
        state = { count: 0, value: element[property] };
        properties.set(property, state);
    }
    state.count++;
    element[property] = value;
    return () => {
        if (--state.count) return;
        element[property] = state.value;
        properties.delete(property);
    };
}

export function ownPopover(panel, modal) {
    surfaces.push(panel);
    const releases = [];
    if (modal) {
        for (const sibling of document.body.children) {
            if (sibling.contains(panel) || sibling.classList.contains("cell-popover__backdrop"))
                continue;
            releases.push(lock(sibling, "inert", true));
        }
        for (const element of new Set([
            document.documentElement,
            document.body,
            document.querySelector("#main-content")
        ])) {
            if (element) releases.push(lock(element.style, "overflow", "hidden"));
        }
    }
    let released = false;
    return {
        isTop: () => surfaces.at(-1) === panel,
        release() {
            if (released) return;
            released = true;
            const index = surfaces.indexOf(panel);
            if (index >= 0) surfaces.splice(index, 1);
            releases.reverse().forEach((release) => release());
        }
    };
}

export function popoverFocusable(panel) {
    return [
        ...(panel?.querySelectorAll("button, a[href], input, select, textarea, [tabindex]") || [])
    ].filter(
        (element) =>
            !element.disabled &&
            element.tabIndex >= 0 &&
            !element.closest('[hidden], [inert], [aria-hidden="true"]') &&
            getComputedStyle(element).display !== "none" &&
            getComputedStyle(element).visibility !== "hidden" &&
            !hasHiddenParent(element, panel)
    );
}

function hasHiddenParent(element, panel) {
    for (
        let parent = element.parentElement;
        parent && parent !== panel;
        parent = parent.parentElement
    ) {
        if (getComputedStyle(parent).display === "none") return true;
    }
    return false;
}
